<template>
  <div class="d-flex">
    <div>
      <PreviewImage
        :src="imageSource"
        size="tiny"/>
    </div>
    <div class="ms-4 justify-content-start">
      <h5>
        {{ itemStyle.brand }} {{ itemStyle.subcategory }}
      </h5>
      <p class="size-subtext mt-sm text-start">
        Size {{ size }}
      </p>
    </div>
  </div>
</template>

<script setup>
import PreviewImage from '@shared/components/ADORN/PreviewImage.vue'

defineProps({
  imageSource: {
    type: String,
    required: true
  },
  compact: {
    type: Boolean,
    default: false
  },
  itemStyle: {
    type: Object,
    required: true
  },
  size: {
    type: String,
    required: true
  }
})
</script>

<style lang="scss" scoped>
@import './ReviewItem.scss';

.size-subtext {
  color: $pewter;
  font-size: 16px;
  font-family: 'Open Sans';
  font-weight: 400;
  line-height: 22.50px;
}

.review-item {
  width: 100%;
  border: $default-border;
}
</style>
